// extracted by mini-css-extract-plugin
export default {"registerContainer":"LoginPage_registerContainer__NRIAK"};